import React from "react";
import TransactionListASAP from "./TransactionListASAP"

export default class Return extends React.Component {

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        localStorage.setItem('TransactionType', JSON.stringify(1));
    }

    render() {
        return (
            <div>
                <TransactionListASAP type={1} history={this.props.history} delivery={false}></TransactionListASAP>
            </div>
        );
    }

}